<template>
  <div class="animation" ref="animationWrapper">
    <img
      v-for="imageIndex in 28"
      :src="require(`@/assets/images/fox/${imageIndex}.png`)"
      :class="{ '--visible': imageIndex === 1 }"
      :ref="`animationImage${imageIndex}`"
    >
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'

const animationInterval = ref(null)
const animationWrapper = ref(null)

onMounted(() => {
  animationInterval.value = animateImage('.animation', 28, 60)
})

onUnmounted(() => clearInterval(animationInterval.value))

function animateImage(className, count, speed = 60) {
  let x = 1

  const animate = () => {
    const nextIndex = x === count ? 1 : x + 1

    const currentImage = animationWrapper.value.children[x - 1]
    const newImage = animationWrapper.value.children[nextIndex - 1]

    currentImage.classList.remove('--visible')
    newImage.classList.add('--visible')

    x = nextIndex
  }

  animate()

  return setInterval(animate, speed)
}
</script>

<style lang="sass">
.animation
  max-width: 310px
  min-height: 210px
  width: 100%

  img
    display: none
    transform: rotate(-12deg)
    width: inherit
    max-width: inherit

  .--visible
    display: block

</style>